export const PERSON_MEDIA_TYPES = ['image', 'video'] as const;

export type PersonMediaType = (typeof PERSON_MEDIA_TYPES)[number];
